import { render, staticRenderFns } from "./CreateNewReport.vue?vue&type=template&id=1dd2d01d"
import script from "./CreateNewReport.vue?vue&type=script&lang=js"
export * from "./CreateNewReport.vue?vue&type=script&lang=js"
import style0 from "./CreateNewReport.vue?vue&type=style&index=0&id=1dd2d01d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports